export const transactionServiceTypes = {
    downloadServerStrategy: Symbol('TransactionDownloadServerStrategy'),
} as const;
